import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCleanseGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.72 25.365a5.585 5.585 0 1 0 0 11.17 5.585 5.585 0 0 0 0-11.17Zm-6.835 5.585a6.835 6.835 0 1 1 13.67 0 6.835 6.835 0 0 1-13.67 0ZM11.3 19.465a2.055 2.055 0 1 0 0 4.11 2.055 2.055 0 0 0 0-4.11ZM7.995 21.52a3.305 3.305 0 1 1 6.61 0 3.305 3.305 0 0 1-6.61 0Z",
    fill: "currentColor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.835 14.274a9.645 9.645 0 0 0-11.784 10.523l-1.242.146a10.895 10.895 0 1 1 7.723 9.166l.356-1.198a9.645 9.645 0 1 0 4.947-18.637Z",
    fill: "currentColor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.79 18.59a6.376 6.376 0 0 0-2.286-1.22l.352-1.2c1 .294 1.93.79 2.731 1.457a7.735 7.735 0 0 1 2.782 4.948l-1.238.17a6.485 6.485 0 0 0-2.335-4.15l-.006-.005ZM19.39 7.997l1-.003.09 1.753a.76.76 0 0 0 .723.724h.003l1.75.09-.003.998-1.75.08a.76.76 0 0 0-.723.724l-.169-.008v.002l.168.009-.09 1.75-.998-.003-.08-1.75a.761.761 0 0 0-.724-.723l-1.75-.08-.003-1 1.753-.09a.76.76 0 0 0 .724-.723l.08-1.75ZM36.73 35.577a.76.76 0 0 0 .723.724l1.75.08v.998l-1.746.08a.78.78 0 0 0-.728.736l-.08 1.738-.998.003-.09-1.74a.78.78 0 0 0-.728-.737l-1.736-.08v-.998l1.74-.08a.76.76 0 0 0 .723-.724v-.003l.09-1.75 1 .003.08 1.75ZM19.835 28.782a2.425 2.425 0 0 0-.914-.259l.098-1.246a3.675 3.675 0 0 1 3.374 3.976l-1.246-.106a2.426 2.426 0 0 0-1.312-2.365Z",
    fill: "currentColor"
  }));
}

export { SvgCleanseGlyph as default };
